import { render, staticRenderFns } from "./dias-laborales-ver.vue?vue&type=template&id=8bc4d492&scoped=true&"
import script from "./dias-laborales-ver.vue?vue&type=script&lang=js&"
export * from "./dias-laborales-ver.vue?vue&type=script&lang=js&"
import style0 from "./dias-laborales-ver.vue?vue&type=style&index=0&id=8bc4d492&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc4d492",
  null
  
)

export default component.exports